import React, { useEffect, useState } from 'react';

const ReceiptLog = () => {
  const [receipts, setReceipts] = useState([]);

  useEffect(() => {
    fetch('https://loyaltyprogram.navalsupermart.com/api/receiptlog.php')
      .then(res => res.json())
      .then(data => setReceipts(data))
      .catch(err => console.error('Failed to fetch receipts:', err));
  }, []);

  return (
    <div>
      <h2>Receipt Log</h2>
      {receipts.length === 0 ? (
        <p>No receipts recorded yet.</p>
      ) : (
        <table border="1" cellPadding="8">
          <thead>
            <tr>
              <th>Receipt #</th>
              <th>Customer</th>
              <th>Amount</th>
              <th>Points Awarded</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {receipts.map((r, index) => (
              <tr key={index}>
                <td>{r.receipt_number}</td>
                <td>{r.customer_name}</td>
                <td>₱{parseFloat(r.amount).toFixed(2)}</td>
                <td>{r.points_awarded}</td>
                <td>{r.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ReceiptLog;
